









import Vue, { PropType } from 'vue';
import { InputState } from '../forms.types';
import BaseTextarea from '../bases/BaseTextarea/BaseTextarea.vue';
import BaseInput from '../bases/BaseInput/BaseInput.vue';
import InputWrapper from '../bases/InputWrapper/InputWrapper.vue';
import BaseFormElem from '../bases/BaseFormElem.vue';

export default Vue.extend({
  name: 'Input',
  extends: BaseFormElem,
  components: {InputWrapper, BaseInput, BaseTextarea},
  props: { // input wrapper props
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String as PropType<'default' | 'small'>,
      default: 'default',
    },
    state: {
      type: String as PropType<InputState>,
      default: 'default',
    },
    hasIcon: {
      type: Boolean,
      default: false,
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
    multiline: {
      type: Boolean,
      default: false,
    },
  },
});
